import { Formats } from 'react-big-calendar';
import { PlanningEntityType } from 'generated/index';
import { ShortcutKeySet } from 'components/shared/ShortcutProvider';

/**
 * @description Decouple control over calendar events by React Big Calendar
 */
export const CalendarDnDKitDefaults = {
  selectable: true,
  longPressThreshold: 10
};

export const formats: Formats = {
  dateFormat: 'dd',
  timeGutterFormat: 'HH:mm'
};

export const EntityType = {
  EMPLOYEE: 'EMPLOYEE',
  RESOURCE: 'RESOURCE',
  CLIENT: 'CLIENT',
  WORKPLACE: 'WORKPLACE'
} as const satisfies Record<string, PlanningEntityType>;

/**
 * @description Entity types that show hover tooltip in calendar header.
 * Add entity types here to enable hover info for that type.
 */
export const ENTITY_TYPES_WITH_HOVER_TOOLTIP: PlanningEntityType[] = [
  EntityType.CLIENT
];

export const StoreStorageSyncKeys = {
  APPOINTMENT_STORE: 'mrp.appointmentStoreSync',
  CALENDAR_STORE: 'mrp.calendarStoreSync',
  CONTEXT_PANEL_STORE: 'mrp.contextPanelStoreSync',
  ENTITY_STORE: 'mrp.entityStoreSync'
} as const;

export const MrpShortcuts: Record<string, ShortcutKeySet> = {
  COPY_APPOINTMENT: {
    activatorKey: 'C',
    controllerKeys: ['PRIMARY']
  },
  CUT_APPOINTMENT: {
    activatorKey: 'X',
    controllerKeys: ['PRIMARY']
  },
  QUICK_CONNECT: {
    activatorKey: 'K',
    controllerKeys: ['PRIMARY']
  },
  QUICK_DISCONNECT: {
    activatorKey: 'K',
    controllerKeys: ['PRIMARY', 'SHIFT']
  },
  OPEN_CALENDAR: {
    activatorKey: 'O',
    controllerKeys: ['PRIMARY']
  },
  NEW_APPOINTMENT: {
    activatorKey: 'ENTER',
    controllerKeys: ['SHIFT']
  },
  PASTE_APPOINTMENT: {
    activatorKey: 'V',
    controllerKeys: ['PRIMARY']
  },
  DUPLICATE_APPOINTMENT: {
    activatorKey: 'D',
    controllerKeys: ['PRIMARY']
  },
  DUPLICATE_RECURRING_APPOINTMENT: {
    activatorKey: 'D',
    controllerKeys: ['PRIMARY', 'SHIFT']
  },
  EDIT_APPOINTMENT: {
    activatorKey: 'ENTER',
    controllerKeys: []
  },
  DELETE_APPOINTMENT: {
    activatorKey: 'DELETE',
    controllerKeys: []
  },
  DELETE_APPOINTMENT_MAC_OS: {
    activatorKey: 'BACKSPACE',
    controllerKeys: ['PRIMARY']
  },
  TOGGLE_TOOLTIP: {
    activatorKey: 'SPACE',
    controllerKeys: []
  }
} as const;
